(function () {
  function initWingspan(section) {
    if (!section || section.dataset.wingspanInitialized === 'true') return;
    section.dataset.wingspanInitialized = 'true';

    const cards = Array.from(section.querySelectorAll('.wingspan__card'));
    const images = Array.from(section.querySelectorAll('.wingspan__image'));
    const buttons = cards.map((card) => card.querySelector('.button, .wingspan__button'));

    function setActive(index) {
      cards.forEach((card, i) => card.classList.toggle('is-active', i === index));
      images.forEach((image, i) => image.classList.toggle('is-active', i === index));

      buttons.forEach((button, i) => {
        if (!button) return;
        // Base button class stays; we only toggle outline modifier
        if (i === index) {
          button.classList.remove('button--outline');
        } else {
          if (!button.classList.contains('button')) {
            button.classList.add('button');
          }
          button.classList.add('button--outline');
        }
      });
    }

    buttons.forEach((button, index) => {
      if (!button) return;
      button.addEventListener('click', () => setActive(index));
    });

    // Ensure initial state matches Liquid's default active card
    const initialIndex = Math.max(
      0,
      cards.findIndex((card) => card.classList.contains('is-active'))
    );
    setActive(initialIndex);
  }

  function initAll() {
    document.querySelectorAll('[data-wingspan]').forEach((section) => initWingspan(section));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target?.querySelector?.('[data-wingspan]') || event.target;
    if (section?.matches?.('[data-wingspan]')) initWingspan(section);
  });
})();

